export const colors = {
  primary: {
    teal: '#438582', // Primary Teal (FR-001)
    darkBlueGray: '#3b546b', // Dark Blue-Gray (FR-001)
  },
  text: {
    primary: '#000000',
    secondary: '#666666',
    disabled: '#999999',
    error: '#d32f2f',
    success: '#388e3c',
  },
  background: {
    primary: '#ffffff',
    secondary: '#f9f9f9', // Striped grid rows
    disabled: '#e0e0e0',
  },
  border: {
    default: '#e0e0e0',
    focus: '#438582',
    error: '#d32f2f',
  },
} as const;
